import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function CompanySiteHeader({ company, basePath }) {
  const logoUrl = company?.logoUrl || '/logo.svg';
  const companyName = company?.name || 'Company';
  const path = basePath || '';

  return (
    <header className="company-site-header">
      <div className="company-site-header-inner">
        <Link to={path} aria-label={companyName}>
          <img
            src={logoUrl}
            alt={companyName}
            className="company-site-logo"
            onError={(e) => {
              const img = e.target;
              if (img) img.src = '/logo.svg';
            }}
          />
        </Link>
        <nav className="company-site-nav">
          <a href={`${path}#hero`}>Trang chủ</a>
          <a href={`${path}#about`}>Giới thiệu</a>
          <a href={`${path}#jobs`}>Việc làm</a>
          <a href={`${path}#contact`}>Liên hệ</a>
        </nav>
      </div>
    </header>
  );
}

CompanySiteHeader.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    logoUrl: PropTypes.string,
  }),
  basePath: PropTypes.string,
};

CompanySiteHeader.defaultProps = {
  company: null,
  basePath: '',
};

export default CompanySiteHeader;
